module.exports = __webpack_public_path__ + "img/logo+slogan.c56abca0.png";